import React from 'react';

// A three-part chip that appears next to every Sales tile:
//   [Source · As of · Confidence]
// This is the primitive that makes the "labelled sources, freshness, and
// confidence" rule visible everywhere without prose.
export function DataSourceBadge({ source, asOf, confidence = 'green', testId }) {
  const conf = {
    green: 'bg-emerald-600 text-white',
    amber: 'bg-amber-500 text-indie-ink',
    red: 'bg-rose-600 text-white',
    unknown: 'bg-indie-ink/30 text-indie-ink',
  }[confidence] || 'bg-indie-ink/30 text-indie-ink';

  return (
    <div
      data-testid={testId || 'data-source-badge'}
      className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.14em] font-semibold"
    >
      <span className="px-1.5 py-0.5 bg-indie-ink/10 text-indie-ink border border-indie-ink/15">
        {source}
      </span>
      {asOf && (
        <span className="px-1.5 py-0.5 bg-indie-cream text-indie-ink/70 border border-indie-ink/10">
          As of {asOf}
        </span>
      )}
      <span className={`px-1.5 py-0.5 ${conf}`}>
        {confidence}
      </span>
    </div>
  );
}
